import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import SectionContent from "../../../components/sectionContent/sectionContent";
import RetailOutlets from "../../../pages/tunder/retailOutlets/retailOutlets";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const RetailOutletsApp = () => {
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        section="Тандер"
        title="Торговые точки"
        headBlockChildren={
          <>
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <HeaderBtn
                content="Загрузить торговые точки"
                purpose="outletsDownload"
                modalTitle="Загрузить торговые точки"
              />
            )}
          </>
        }
      >
        <div className="content__main">
          <div className="btns">
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/shops" className="tab">
                <div className="buttons__btn --active">Торговые точки</div>
              </Link>
            )}
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/signals" className="tab">
                <div className="buttons__btn">Сигналы</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/properties" className="tab">
                <div className="buttons__btn">Настройки</div>
              </Link>
            )}
            <Link to="/tunder/goods" className="tab">
              <div className="buttons__btn">Товары</div>
            </Link>
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/access" className="tab">
                <div className="buttons__btn">Доступы</div>
              </Link>
            )}
          </div>
          <RetailOutlets />
        </div>
      </SectionContent>
    </div>
  );
};

export default RetailOutletsApp;
